import {combineReducers} from 'redux';

import ariaAttributesReducer from './ariaReducer';
import context from './context';
import message from './message';
import modal from './modalReducer';
import screenSize from './screenSize';
import welcomeBack from './welcomeBack';


export default combineReducers({
  ariaAttributesReducer,
  modal,
  screenSize,
  welcomeBack,
  message,
  context
});
